<template>
  <el-dialog
    title=""
    :visible="visible"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    v-bind="$attrs"
    class="s-dialog"
  >
    <div class="s-dialog-main">
      <div class="s-dialog-header">
        <div class="text">{{ title }}</div>
      </div>

      <div class="s-dialog-content">
        <slot name="content"></slot>
      </div>

      <div class="s-dialog-footer">
        <slot name="footer"></slot>
      </div>

      <i class="s-dialog-close el-icon-close icon" @click="close" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SDialog',
  props: {
    title: {
      required: true,
      type: String,
      default: ''
    },
    visible: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      // this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.s-dialog {
  >>> .el-dialog__header {
    display: none;
  }
}
.s-dialog-main {
  position: relative;
}
.s-dialog-header {
  margin-bottom: 20px;
  border-bottom: 1px solid #dcdcdc;

  .text {
    position: relative;
    width: fit-content;
    padding-bottom: 15px;
    color: #0062FF;

    &::after {
      content: ' ';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 4px;
      border-radius: 4px;
      background-color: #0062FF;
    }
  }
}

.s-dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
}

.s-dialog-close {
  position: absolute;
  right: -10px;
  top: -10px;
  z-index: 1;
  cursor: pointer;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/SDialog/index.vue